function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13.869 1.65l2 4.1c.3.6.9 1.1 1.7 1.2l4.5.7c1.8.3 2.5 2.5 1.2 3.7l-3.3 3.2c-.5.5-.8 1.2-.6 1.9l.8 4.5c.3 1.8-1.6 3.2-3.2 2.3l-4-2.1c-.6-.3-1.4-.3-2 0l-4 2.1c-1.6.8-3.5-.5-3.2-2.3l.8-4.5c.1-.7-.1-1.4-.6-1.9l-3.3-3.2c-1.3-1.3-.6-3.5 1.2-3.7l4.4-.7c.7-.1 1.3-.6 1.6-1.2l2-4.1c.8-1.6 3.2-1.6 4 0z",
  fill: "#231F20",
  fillRule: "evenodd"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgComponent;